import React from 'react';
import { Menu } from '@material-ui/icons';
import { Link } from "react-scroll";

class NavigationBar extends React.Component{
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.i18n = this.props.i18n;
    this.state = {
      navCollapsed: false,
    }
  }
  
  toggleNav() {
    this.setState({
      navCollapsed: !this.state.navCollapsed,
    });
  }
  
  changeLanguage = (ln)=>{
    this.props.changeLanguage(ln);
  }

  render(){
    return (
      <div className="navigation-bar">
          <div className='main-content big-nav'>
              <nav className='left-nav '>
                  <ul>
                    <Link
                      activeClass="active"
                      to="name"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}>
                        <li>{this.i18n.t('nav.name')}</li>
                    </Link>
                    <Link
                      activeClass="active"
                      to="story"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}>
                        <li>{this.i18n.t('nav.story')}</li>
                    </Link>
                    <Link
                      activeClass="active"
                      to="association"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}>
                        <li>{this.i18n.t('nav.association')}</li>
                    </Link>
                    <Link
                      activeClass="active"
                      to="members"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}>
                        <li>{this.i18n.t('nav.members')}</li>
                    </Link>
                    <Link
                      activeClass="active"
                      to="contact"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}>
                        <li>{this.i18n.t('nav.contact')}</li>
                    </Link>
                  </ul>
              </nav>
              <nav className='right-nav'>
                  <ul>
                    <li onClick={() => this.changeLanguage('sr')}>SR</li>
                    <li onClick={() => this.changeLanguage('en')}>EN</li>
                    <li onClick={() => this.changeLanguage('fr')}>FR</li>
                  </ul>
              </nav>
          </div>
          <div className='main-content small-nav-wrap'>
              <nav className={`left-nav ${this.state.navCollapsed ? '' : 'hidden'}`}>
                <ul>
                  <Link
                    onClick={() => this.toggleNav()}
                    activeClass="active"
                    to="name"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}>
                      <li>{this.i18n.t('nav.name')}</li>
                  </Link>
                  <Link
                    onClick={() => this.toggleNav()}
                    activeClass="active"
                    to="story"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}>
                      <li>{this.i18n.t('nav.story')}</li>
                  </Link>
                  <Link
                    onClick={() => this.toggleNav()}
                    activeClass="active"
                    to="association"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}>
                      <li>{this.i18n.t('nav.association')}</li>
                  </Link>
                  <Link
                    activeClass="active"
                    to="members"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}>
                      <li>{this.i18n.t('nav.members')}</li>
                  </Link>
                  <Link
                    onClick={() => this.toggleNav()}
                    activeClass="active"
                    to="contact"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}>
                      <li>{this.i18n.t('nav.contact')}</li>
                  </Link>
                  <li onClick={() => this.changeLanguage('sr')}>SR</li>
                  <li onClick={() => this.changeLanguage('en')}>EN</li>
                </ul>
              </nav>
              <button className="nav-toggle" onClick={() => this.toggleNav()}><Menu/></button>
          </div>
      </div>
    )
  }
}

export default NavigationBar;
